import WebsiteResource from '@/resources/WebsiteResource';

export default class Domain {
    constructor() {
        this.Resource = new WebsiteResource()
    }

    async get () {
        const domain = await this.Resource.get()
        return domain.data.me.websites
    }

    async getById (id) {
        const domain = await this.Resource.getById(id)
        return domain.data.me.websites[0]
    }

    async delete (id) {
        return await this.Resource.delete(id)
    }

    async create (name, currency) {
        const domain = await this.Resource.create(name, currency)
        return domain.data.addWebsite
    }

    async delete (id) {
        return await this.Resource.delete(id)
    }

    async update(website) {
        return await this.Resource.update(website)
    }

    async disconnectIntegration (websiteId, integration) {
        return await this.Resource.disconnectIntegration(websiteId, integration)
    }

    async toggleDeprecatedStatus(id) {
        return await this.Resource.toggleDeprecatedStatus(id)
    }

    async toggleBingAdsDeprecatedStatus(id) {
        return await this.Resource.toggleBingAdsDeprecatedStatus(id)
    }

    async toggleGoogleAnalyticsDeprecatedStatus(id) {
        return await this.Resource.toggleGoogleAnalyticsDeprecatedStatus(id)
    }

    async toggleMediaDeprecatedStatus(websiteId, accountId) {
        return await this.Resource.toggleMediaDeprecatedStatus(websiteId, accountId)
    }
}
